import React from 'react'

import listen1 from '../assets/listen-1.jpg'
import listen2 from '../assets/listen-2.jpg'
import listen3 from '../assets/listen-3.jpg'

const ApproachFooter = () => {
    return (
        <section className="cases">
            <div className="container-fluid">
                <div className="row">
                    <div className="case">
                        <div className="case-details">
                            <span>
                                <span className="inline-block px-2 pt-1"></span>
                            </span>

                        </div>
                        <div className="about-case-image">
                            <img src={listen1} alt='my alt'/>
                        </div>
                    </div>
                    <div className="case">
                        <div className="case-details">
                            <span>
                                <span className="inline-block px-2 pt-1"></span>
                            </span>

                        </div>
                        <div className="about-case-image">
                            <img src={listen2} alt='my alt'/>
                        </div>
                    </div>
                    <div className="case">
                        <div className="case-details">
                            <span>
                                <span className="inline-block px-2 pt-1"></span>
                            </span>

                        </div>
                        <div className="about-case-image">
                            <img src={listen3} alt='my alt'/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ApproachFooter
